module.exports = " <div class=\"row text-center\"> <h2>¡hubo un problema al procesar tu pedido!</h2> <p class=\"text-center padding-extra\">Por favor revise su método de pago</p> <a v-link=\"{ path: '/carrito-de-compra' }\"><button type=button class=\"btn btn-black\" style=\"margin-left: 15px\">Regresar al carrito</button></a> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shopping-cart/Shopping-cart-error.vue
// module id = 560
// module chunks = 0